import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { FieldTemplateMap } from '../models';
import { FormTemplateMapState } from '../reducers/form-template-map.reducer';

export const selectFormTemplateMapState =
  createFeatureSelector<FormTemplateMapState>('formTemplateMap');

export const selectFormTemplateMapPageLoading = createSelector(
  selectFormTemplateMapState,
  (state) => state.pageLoading,
);

export const selectFormTemplateMapActionLoading = createSelector(
  selectFormTemplateMapState,
  (state) => state.actionLoading,
);

export const selectFormTemplateMapShowInitWaitingMessage = createSelector(
  selectFormTemplateMapState,
  (state) => state.showInitWaitingMessage,
);

export const selectFormTemplateMapError = createSelector(
  selectFormTemplateMapState,
  (state) => state.error,
);

export const selectFormTemplateMapPage = createSelector(selectFormTemplateMapState, (state) => {
  const formTemplateMaps: FieldTemplateMap[] = [];
  each(state.ids, (id: number) => formTemplateMaps.push(state.entities[id]));

  return new QueryResultsModel(formTemplateMaps, state.totalCount);
});
